class HeapService
  $get: ["$q", "$timeout", "$window", "AvantErrorService", "ConfigService", "CONFIG", "$rootScope", ($q, $timeout, $window, AvantErrorService, ConfigService, CONFIG, $rootScope) ->
    if ConfigService.heapEnabled && !$window.heap?.loaded && $window.heap?.load?
      $window.heap.load CONFIG.heapToken, {'forceSSL': true, 'secureCookie': true, 'disableTextCapture': true}

    heapFn = (name) ->
      ->
        args = arguments
        if @addPrefix
          for arg, index in args
            if (typeof arg).toLowerCase() is "string"
              args[index] = "admin_user:#{arg}"
        try
          analytics.heap name, args
        catch error
        deferred = $q.defer()

        heapCheck = ->
          if $window.heap?.loaded
            [context..., func] = name.split '.'
            scope = $window.heap
            scope = scope[c] for c in context
            result = scope[func].apply(scope, args)
            deferred.resolve(result)
          else
            $timeout (-> heapCheck()), 500

        if ConfigService.heapEnabled
          heapCheck()
        else
          deferred.reject('Heap is not enabled')

        deferred.promise

    customerAuthenticated = (is_authenticated) ->
      heapFn('addEventProperties') {'Is Authenticated': is_authenticated}
        .catch(logError('HeapService could not set customer.is_authenticated'))

    setCreditDecisionId = (decision_id) ->
      if decision_id
        heapFn('addEventProperties') {'Credit Decision Id': decision_id}
          .catch(logError('HeapService could not set credit decision ID'))

    setLeadId = (lead_id) ->
      if lead_id
        heapFn('addEventProperties') {'Lead Id': lead_id}
          .catch(logError('HeapService could not set lead ID'))

    setLoanId = (loan_id) ->
      if loan_id
        heapFn('addEventProperties') {'Loan Id': loan_id}
          .catch(logError('HeapService could not set loan ID'))

    setProductType = (product_type) ->
      if product_type
        heapFn('addEventProperties') {'Product Type': product_type}
          .catch(logError('HeapService could not set product type'))

    setCustomerApplication = (app_id) ->
      heapFn('addEventProperties') {'Customer Application Id': app_id}
        .catch(logError('HeapService could not set customer application ID'))

    setCustomerApplicationData = (data) ->
      if data.is_authenticated
        heapFn('identify')(data.customer_id)
          .catch(logError('HeapService could not set customer identity'))

      setCustomerApplication data.customer_application_id
      setLeadId data.lead_id
      setCreditDecisionId data.credit_decision_id
      customerAuthenticated data.is_authenticated
      setProductType data.product_type
      setCustomerApplicationOwner data.customer_application_owner

    setCustomerApplicationOwner = (application_owner) ->
      if application_owner
        heapFn('addEventProperties') {'Application Owner': application_owner}
          .catch(angular.noop) # TODO: Handle this rejection

    logError = (error) ->
      # These promises sometimes get rejected even when Heap is enabled. This
      # behavior is not new, but it wasn't apparent until AngularJS 1.6 when
      # AngularJS began raising errors for possibly unhandled rejections. We
      # can't log these because there are too many for Sentry to deal with.
      angular.noop()

    addPrefix: false
    identify: heapFn 'identify'
    addEventProperties: heapFn 'addEventProperties'
    removeEventProperty: heapFn 'removeEventProperty'
    clearEventProperties: heapFn 'clearEventProperties'
    track: heapFn 'track'
    userId: heapFn 'userId'
    customerAuthenticated: customerAuthenticated
    setCreditDecisionId: setCreditDecisionId
    setCustomerApplication: setCustomerApplication
    setLeadId: setLeadId
    setLoanId: setLoanId
    setProductType: setProductType
    setCustomerApplicationData: setCustomerApplicationData
    setCustomerApplicationOwner: setCustomerApplicationOwner
    ]

angular
.module("avant.heap")
.provider("HeapService", HeapService)
.run(["$window", "HeapService", ($window, HeapService) ->
  if $window.avant?.customer?.id
    HeapService.identify $window.avant.customer.id
    HeapService.customerAuthenticated true
])


if typeof exports != 'undefined'
  if typeof module != 'undefined' && module.exports
    exports = module.exports = HeapService
  exports.HeapService = HeapService
else
  window.HeapService = HeapService
